/**
 * REEMPLAZA: frontend/src/api.js
 * Agrega exportación de C para que Home.js pueda usarlo
 */
export const API = "/api";

export async function apiFetch(path, opts = {}) {
  const token = localStorage.getItem("token");
  const res = await fetch(`${API}${path}`, {
    ...opts,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(opts.headers || {}),
    },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || "Request failed");
  return data;
}

export const LANG_MAP = {
  py:"python", js:"javascript", ts:"typescript", json:"json",
  html:"html", css:"css", md:"markdown", sh:"shell",
  txt:"plaintext", yml:"yaml", yaml:"yaml", jsx:"javascript", tsx:"typescript",
};

export function langFromPath(path) {
  const ext = path.split(".").pop();
  return LANG_MAP[ext] || "plaintext";
}

export const C = {
  bg:"#0d0d0f", surface:"#111115", surface2:"#16161c",
  border:"#1e1e26", accent:"#f0ec57", text:"#e8e6e1",
  muted:"#555", error:"#ff6b6b", success:"#57f0a0", warn:"#ffa94d",
};
